const i18n = {
	acceptFilters: {
		0 : "Ужыць фільтры",
		1 : "Применить фильтры"
	},
	resetFilters: {
		0 : "Скінуць фільтры",
		1 : "Сбросить фильтры"
	},
	filtersNames: {
		0: [
			"Статус",
			"Адпраўнік",
			"Выканаўца",
			"Дата рэгістрацыі",
			"Тэрмін выканання",
			"Дата адказу"
		],
		1: [
			"Статус",
			"Отправитель",
			"Исполнитель",
			"Дата регистрации",
			"Срок исполнения",
			"Дата ответа"
		]
	},
	filtersPlaceholders: {
		0: [
			"Абярыце статус даручэння",
			"Увядзіце назву арганізацыі або УНП",
			"Пачатак",
			"Канец",
			"Увядзіце тэкст даручэння"
		],
		1: [
			"Выберите статус поручения",
			"Введите название организации или УНП",
			"Начало",
			"Конец",
			"Введите текст поручения"
		]
	},
	headerReOrgAppealMissions: {
		0 : "Даручэнне у арганізацыю",
		1 : "Поручение в организацию"
	},
	tabNames: {
		0: [
			"Усе даручэнні для арганізацыі",
			"Неадказныя даручэнні для арганізацыі",
			"Адказаныя даручэнні для арганізацыі",
			"Усе даручэнні з арганізацыі",
			"Неадказныя даручэнні з арганізацыі",
			"Адказаныя даручэнні з арганізацыі"
		],
		1: [
			"Все поручения для организации",
			"Неотвеченные поручения для организации",
			"Отвеченные поручения для организации",
			"Все поручения из организации",
			"Неотвеченные поручения из организации",
			"Отвеченные поручения из организации"
		]
	},
	tableEmpty: {
		0 : "Даручэнні адсутнічаюць.",
		1 : "Поручения отсутствуют."
	},
	tableItems: {
		0: [
			"Арганізацыя-адпраўнік",
			"Арганізацыя-атрымальнік",
			"Дата стварэння",
			"Дата рэгістрацыі",
			"Тэрмін выканання",
			"Дата адказу",
			"Выканаўца",
			"Зварот",
			"Статус"
		],
		1: [
			"Организация-отправитель",
			"Организация-получатель",
			"Дата создания",
			"Дата регистрации",
			"Срок исполнения",
			"Дата ответа",
			"Исполнитель",
			"Обращение",
			"Статус"
		]
	},
	reOrgAppealMissionModalHeader: {
		0 : "Даручэнне",
		1 : "Поручение"
	},
	reOrgAppealMissionText: {
		1 : "Текст поручения",
		0 : "Тэкст даручэння"
	},
	reOrgAppealMissionFiles: {
		1 : "Файлы поручения",
		0 : "Файлы даручэння"
	},
	reOrgAppealMissionModalSubmitButtonLabel: {
		1 : "Направить поручение",
		0 : "Накіраваць даручэнне"
	},
	createReOrgAppealMissionMessage: {
		1 : "Уверены, что хотите направить поручение?",
		0 : "Упэўненыя, што хочаце накіраваць даручэнне?"
	},
	createResponseForReOrgAppealMissionMessage: {
		1 : "Уверены, что хотите направить ответ на поручение?",
		0 : "Упэўненыя, што жадаеце накіраваць адказ на даручэнне?"
	},
	reOrgAppealMissionReOrgReceiver: {
		1 : "Организация-получатель поручения",
		0 : "Арганізацыя-атрымальнік даручэння"
	},
	createReOrgAppealMissionModalHeader: {
		1 : "Создание поручения",
		0 : "Стварэнне даручэння"
	},
	noDataChange: {
        1 : "Данные не были изменены",
        0 : "Дадзеныя не былі зменены"
    },
	reOrgAppealMissions: {
		1 : "Поручения",
		0 : "Даручэнні"
	},
	createReOrgAppealMission: {
		1 : "Создать поручение",
		0 : "Стварыць даручэнне"
	},
	reOrgAppealMissionReferringOrganization: {
		1 : "Организация направитель",
		0 : "Арганізацыя накіравальнік"
	},
	reOrgAppealMissionReferringPerson: {
		1 : "Направитель поручения",
		0 : "Накіроўнік даручэння"
	},
	signer: {
		1 : 'Подписант:\n{0}',
		0 : 'Падпісант:\n{0}'
	},
	reOrgAppealMissionResponseText: {
		1 : 'Текст ответа',
		0 : 'Тэкст адказу'
	},
	registrationButtonLabel: {
		1 : 'Зарегистрировать',
		0 : 'Зарэгістраваць'
	},
	editButtonLabel: {
		1 : 'Редактировать',
		0 : 'Рэдагаваць'
	},
	addAnswerButtonLabel: {
		1 : 'Добавить ответ',
		0 : 'Дадаць адказ'
	},
	appealExecutorSelect: {
		1 : "Выберите ответственного руководителя",
		0 : "Выберыце адказнага кіраўніка"
	},
	SEDNumberPlaceholder: {
		1 : "Введите номер в СЭД",
		0 : "Увядзіце нумар у СЭД"
	},
	SEDNumber: {
		1 : "Номер в СЭД",
		0 : "Нумар у СЭД"
	},
	reOrgAppealMissionActionMessage: {
		create: {
			1 : "Поручение успешно добавлено",
			0 : "Даручэнне паспяхова дададзена"
		},
		register: {
			1 : 'Поручение успешно зарегистрировано',
			0 : 'Даручэнне паспяхова зарэгістравана'
		},
		update: {
			1 : "Поручение успешно изменено",
			0 : "Даручэнне паспяхова зменена"
		},
		response: {
			1 : "Ответ на поручение успешно добавлен",
			0 : "Адказ на даручэнне паспяхова дададзены"
		}
	},
	responseFiles: {
		1 : "Файлы ответа",
		0 : "Файлы адказу"
	},
	formLabelByStatusCode: {
		1 : [
			"Форма регистрации поручения",
			"Форма ответа на поручение",
			"Форма редактирования поручения"
		],
		0 : [
			"Форма рэгістрацыі даручэння",
			"Форма адказу на даручэння",
			"Форма рэдагавання даручэння"
		]
	},
	enterMissionTextMessage: {
		1 : "Пожалуйста, заполните текст поручения",
		0 : "Калі ласка, запоўніце тэкст даручэння"
	},
	enterResponseTextMessage: {
		1 : "Пожалуйста, заполните текст ответа",
		0 : "Калі ласка, запоўніце тэкст адказу"
	},
	enterExecutorMessage: {
		1 : "Пожалуйста, выберите исполнителя поручения",
		0 : "Калі ласка, абярыце выканаўцу даручэння"
	},
	enterResponseFileMessage: {
		1 : "Пожалуйста, прикрепите файл поручения",
		0 : "Калі ласка, прымацуеце файл даручэння"
	},
	enterEndDueDateMessage: {
		1 : "Пожалуйста, добавьте срок исполнения поручения",
		0 : "Калі ласка, дадайце тэрмін выканання даручэння"
	},
	downloadAllFiles: {
		1: 'Скачать все файлы',
		0: 'Спампаваць усе файлы'
	},
	promptTextForDownloadAppealsZipFile: {
		1: 'Файлы будут загружены .zip архивом.',
		0: 'Файлы будуць загружаны .zip архівам.'
	},
	reOrgAppealMissionZipFileName: {
		1: 'Файлы поручения',
		0: 'Файлы даручэння'
	},
	reOrgAppealMissionResponseZipFileName: {
		1: 'Файлы ответа на поручение',
		0: 'Файлы адказу на даручэнне'
	},
	regNumber: {
		1 : "Номер обращения",
		0 : "Нумар звароту"
	},
	regNumberPlaceholder: {
		1 : "Введите номер обращения",
		0 : "Увядзіце нумар звароту"
	},
	executors: {
		0 : "Выканаўцы",
		1 : "Исполнители"
	},
	sender: {
		0 : 'Прызначыў',
		1 : 'Назначил'
	},
	filesMaxCountErrorNotice: {
		1: "Нельзя добавлять больше {0} файлов!",
		0: "Нельга дадаваць больш {0} файлаў!"
	},
	reOrgAppealMissionTextForAppeal: {
		0 : "Тэкст даручэння да звароту №{0}",
		1 : "Текст поручения к обращению №{0}"
	},
	reOrgAppealMissionResponseTextForAppeal: {
		0 : "Тэкст адказу на даручэнне да звароту №{0}",
		1 : "Текст ответа на поручение к обращению №{0}"
	},
}
export default i18n